const messages: Record<string, string> = {
	'vehicleInformation.headline.second': 'Zdjęcie dowodu rejestracyjnego',
	'vehicleInformation.headline.fourth': 'Zdjęcie dowodu rejestracyjnego',
	'vehicleInformation.paragraph.first': 'Przód',
	'vehicleInformation.paragraph.fourth': 'Tył',
	'dashboardMileage.dashboard.paragraph': 'Zrób zdjęcie z widocznym przebiegiem pojazdu.',
	'callback.headline': 'Państwa polisa została przetworzona.',
	'callback.description':
		'Niestety nie można było wygenerować kalkulacji dla tej polisa. Skontaktujemy się z Państwem w ciągu 24h w dni robocze w celu omówienia dalszych kroków.',
	'feedback.headline.policyCheck': 'Dziękujemy za wykorzystanie PolicyCheck!',
	'feedback.rating.policyCheck': 'Jak ocenią Państwo usługę przetwarzania szkód PolicyCheck?',
	'insuranceExpert.description':
		'Dziękujemy bardzo. Państwa polisa została przetworzona. Wkrótce skontaktujemy się z Państwem w celu określenia dalszych kroków.',
	'completeVehicleImagesModal.hasVehicleImageFront': 'Zdjęcie pojazdu z przodu',
	'completeVehicleImagesModal.hasVehicleImageRear': 'Zdjęcie pojazdu z tyłu',
	'completeVehicleImagesModal.hasVehicleImageLeft': 'Zdjęcie pojazdu z lewej strony',
	'completeVehicleImagesModal.hasVehicleImageRight': 'Zdjęcie pojazdu z prawej strony',
	'loader.error': 'Polisa nie może zostać załadowana. Proszę spróbować później...',
	'tutorialModal.paragraph.first':
		'EasyClaim to szybka inspekcja pojazdu. Proces oględzin składa się z 8 prostych kroków.',
	'tutorialModal.paragraph.second':
		'Pamiętaj, aby zdjecia były ostre i wykonane w świetle dziennym.',
	'landing.headline': 'SZYBKA INSPEKCJA POJAZDU',
	'landing.headline.policyCheck': 'SZYBKA INSPEKCJA POJAZDU',
	'landing.paragraph': ' ',
	'landing.stepDescription.vinPicture':
		'Zrób zdjęcie numeru VIN znajdującą się na przedniej szybie lub tabliczce znamionowej, tak aby cały numer VIN był czytelny',
	'landing.termsAndConditionsLinkDescription':
		'W celu rozpoczęcia prosimy zaakceptować regulamin i kliknąc dalej.',
	'landing.aboutPolicyCheck': 'Czym jest PolicyCheck?',
	'waitForAudit.thankYou': 'Dziękujemy za przesłanie dokumentacji!',
	'waitForAudit.description.damageFound':
		'Następny krok należy do nas. O wyniku inspekcji poinformujemy Cię telefonicznie lub mailowo.',
	'waitForAudit.description.damageNotFound':
		'Następny krok należy do nas. O wyniku inspekcji poinformujemy Cię telefonicznie lub mailowo.',
	'waitForAudit.callBack': 'Jeżeli mają Państwa pytania, chętnie Państwu pomożemy:',
	'approval.discount': 'Rabat',
	'necessaryDocuments.paragraph.first':
		'A wykorzystać aplikację PolicyCheck będziesz musiał przygotować następujące zdjęcia: ',
	'imageRecognitionFeedback.isFrontPerspectiveVisible.title': 'Przód pojazdu',
	'imageRecognitionFeedback.isFrontPerspectiveVisible.titleWarning': 'Przód pojazdu niewidoczny',
	'imageRecognitionFeedback.isRearPerspectiveVisible.title': 'Tył pojazdu',
	'imageRecognitionFeedback.isRearPerspectiveVisible.titleWarning': 'Tył pojazdu niewidoczny',
	'imageRecognitionFeedback.isLeftPerspectiveVisible.title': 'Lewa strona pojazdu',
	'imageRecognitionFeedback.isLeftPerspectiveVisible.titleWarning':
		'Lewa strona pojazdu niewidoczna',
	'imageRecognitionFeedback.isRightPerspectiveVisible.title': 'Prawa strona pojazdu',
	'imageRecognitionFeedback.isRightPerspectiveVisible.titleWarning':
		'Prawa strona pojazdu niewidoczna',
	'imageRecognitionFeedback.isFrontPerspectiveVisible.infoText':
		'Upewnij się, że <b>przód</b> pojazdu jest w pełni widoczny.',
	'imageRecognitionFeedback.isRearPerspectiveVisible.infoText':
		'Upewnij się, że <b>tył</b> pojazdu jest w pełni widoczny i kontynuuj.',
	'imageRecognitionFeedback.isLeftPerspectiveVisible.infoText':
		'Upewnij się, że <b>lewa</b> strona pojazdu jest w pełni widoczna i kontynuuj.',
	'imageRecognitionFeedback.isRightPerspectiveVisible.infoText':
		'Upewnij się, że <b>prawa</b> strona pojazdu jest w pełni widoczna i kontynuuj.',
	'review.button.next': 'Zakończ',
	'timeout.bottom': ' ',
	'timeout.headline.first': 'Link jest nieaktywny.',

	'invalidFile.size.title': 'Nieprawidłowy rozmiar zdjęcia',
	'invalidFile.size.description': 'Zdjęcie jest większe niż maksymalny dozwolony rozmiar.',
	'invalidFile.extension.title': 'Nieobsługiwany typ pliku',
	'invalidFile.extension.description':
		'Podany typ pliku nie jest obsługiwany. Obsługiwane typy plików: .jpg, .jpeg, .jfif, .heic, .heif, .png oraz .bmp',
};

export default messages;
